import { gql } from '@apollo/client';

export const LWC_DETAILS_FOR_BROKERAGE_QUERY = gql`
  query LwcDetailsForBrokerage($agentCustomerUuid: String!) {
    odProtosListingsServicesListwithcertaintyproduct {
      getLwcDetailsForBrokerage(input: { agentCustomerId: $agentCustomerUuid }) {
        lwcDetails {
          lwcProduct {
            id
            sellerLeadToken
            state
            agentNote
            cepNote
            leadPassBackNote
            listingId
            presentationType
            timestamps {
              key
              timestamp
            }
          }
          agentLead {
            id
            state
            assignedAgentCustomerId
            assignedBrokerageName
            assignedBrokerageId
            agentAssignedAt
            assignedAgentCustomer {
              fullName
            }
          }
          listing {
            id
            state
            listingPrice
            soldPrice
            grossCommission
            timestamps {
              state
              timestamp
            }
          }
        }
      }
    }
  }
`;
